- name: "Love Is A Verb: Dreaming Abolition in Whatcom County"
  time:
    start: 2022-02-13 16:00:00 -8
    end: 2022-02-13 18:00:00 -8
  button:
    text: Register Now
    url: https://us02web.zoom.us/meeting/register/tZApf-yqqjgjEtUWNIfH9lYD3zGvDhVd9D0S
    class: bg-yellow bn dark-gray
  summary: Whatcom DSA Abolition Working Group is offering up some collective space to dream
